import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import {  FaExclamationCircle, FaTimes } from 'react-icons/fa';
import AdvancedDataTableComponent from '../../common/AdvancedDataTableComponent';
import FloatingLabelInput from '../../ui/FloatingLabelInput';
import FloatingLabelSelect from '../../ui/FloatingLabelSelect';
import Modal from '../../ui/ModalComponentWithButtons';
import { getFilesListByFilters, fetchSubClientData, assignFileDetailsToFO, fetchUploadedDataByFD, updatefiledetails, deletefiledetails } from '../../../services/client/customerApiService';
import { fetchServiceTypeData } from '../../../services/client/serviceTypeApiService';
import { fetchUserDataByRole, fetchRoleData } from '../../../services/client/reportApiService';
import { ProcessingOverlay } from '../../common/ProcessingOverlay';
import Swal from "sweetalert2";
const FileAssigningForm = ({ setSearchResults, handleTableRefresh }) => {
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
    const [formValues, setFormValues] = useState({
        clientId: '',
        serviceTypeId: '',
        subClientId: '',
        checkinId: ''
    });
    const [subClients, setSubClients] = useState([]);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate(); // Initialize useNavigate

    const inputClasses = (field) => (errors[field] ? 'border-red-500' : 'border-gray-300');

    useEffect(() => {
        const fetchServiceTypeByClient = async () => {
            try {
                const data = await fetchServiceTypeData(localStorage.getItem('clientID'));
                setServiceTypes(data.map(obj => ({ value: obj.serviceTypeId, label: obj.serviceType })));
            } catch (error) {
                console.error("Error fetching service types:", error);
            }
        };
        fetchServiceTypeByClient();
    }, []);

    useEffect(() => {
        const getSubClients = async () => {
            try {
                const subClientData = await fetchSubClientData(localStorage.getItem('clientID'));
                setSubClients(subClientData.map(subClient => ({
                    value: subClient.subClientId,
                    label: subClient.subClientName
                })));
            } catch (error) {
                console.error("Error fetching sub-clients:", error);
            }
        };
        getSubClients();
    }, []);

    const validate = () => {
        const newErrors = {};

        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            try {
                // Manually add the clientId here instead of relying on the setFormValues update
                const updatedFormValues = { ...formValues, clientId: localStorage.getItem('clientID') };

                //console.log(updatedFormValues); // You should see the clientId now included here
                const data = await getFilesListByFilters(updatedFormValues);
                if (data.success && data.success.length > 0) {
                    setSearchResults(data.success);
                    setApiResponse({ success: 'Files fetched successfully!' });
                } else {
                    setSearchResults([]);
                    setApiResponse({ error: 'No Data Found' });
                }
            } catch (error) {
                console.error("Submission failed:", error);
                setApiResponse({ error: 'Failed to submit form. Please try again.' });
                setSearchResults([]);
            } finally {
                setLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const resetFormValues = () => {
        setFormValues({
            serviceTypeId: '',
            subClientId: '',
            checkinId: ''
        });
        setErrors({});
    };

    const handleCancel = () => {
        resetFormValues();
        navigate('/fileAssigning');
    };

    return (
        <div className="container mx-auto p-6 bg-white rounded-lg border">
            <form onSubmit={handleSubmit} className="space-y-6 w-full">
                <h1>File Allocation</h1>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        {loading ? (
                            <p>Loading Service Types...</p>
                        ) : (
                            <FloatingLabelSelect
                                label="Select Service Type"
                                id="serviceTypeId"
                                name="serviceTypeId"
                                value={serviceTypes.find(st => st.value === formValues.serviceTypeId) || null}
                                onChange={(option) => setFormValues({ ...formValues, serviceTypeId: option.value })}
                                className={inputClasses('serviceTypeId')}
                                options={serviceTypes}
                                isSearchable={true}
                            />
                        )}
                    </div>
                    <div>
                        <FloatingLabelSelect
                            label="Select Client"
                            id="subClientId"
                            name="subClientId"
                            value={subClients.find(subClient => subClient.value === formValues.subClientId) || null}
                            onChange={(option) => setFormValues({ ...formValues, subClientId: option.value })}
                            className={inputClasses('subClientId')}
                            options={subClients}
                            isSearchable={true}
                        />
                    </div>
                    <div>
                        <FloatingLabelInput
                            label="Checkin ID"
                            id="checkinId"
                            name="checkinId"
                            value={formValues.checkinId}
                            onChange={handleChange}
                            className={inputClasses('checkinId')}
                        />
                    </div>
                </div>

                <div className="flex gap-4">
                    <button
                        type="submit"
                        className={`px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 ${loading ? 'opacity-50' : ''}`}
                        disabled={loading}
                    >
                        {loading ? 'Searching...' : 'Search'}
                    </button>
                    <button
                        type="button"
                        onClick={handleCancel}
                        className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                    >
                        Cancel
                    </button>
                </div>

                {apiResponse && (
                    <motion.div
                        className={`mt-4 flex items-center ${apiResponse.error ? 'text-red-500' : 'text-green-500'}`}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        {apiResponse.error ? (
                            <>
                                <FaExclamationCircle className="mr-2" />
                                {apiResponse.error}
                            </>
                        ) : ''
                            // (
                            //     <>
                            //         <FaCheckCircle className="mr-2" />
                            //         {apiResponse.success}
                            //     </>
                            // )
                        }
                    </motion.div>
                )}
            </form>
        </div>
    );
};


const FilesListTable = ({ list, handleTableRefresh }) => {
    const [checkedItems, setCheckedItems] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalText, setModalText] = useState('');
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [templateContent, setTemplateContent] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    const toggleDialog = () => {
        setIsOpen(!isOpen);
    };
    const handleShowPopoUpSubmit = async (rowObject) => {
        setIsProcessing(true);
        try {
            const fetchUploadedData = await fetchUploadedDataByFD(rowObject.fileDetailsId);
            if (fetchUploadedData.statusCode === 1001) {
                // Parse JSON string into an object
                const parsedData = JSON.parse(fetchUploadedData.result);

                // Add `fileDetailsId` only if it doesn't exist
                if (!parsedData.hasOwnProperty('fileDetailsId')) {
                    parsedData.fileDetailsId = rowObject.fileDetailsId;
                }

                // Convert back to JSON string
                const updatedResult = JSON.stringify(parsedData);
                setTemplateContent(updatedResult);


                toggleDialog(); // Open the dialog after fetching content
            }
        } catch (error) {
            console.error("Error fetching template:", error);
        } finally {
            setIsProcessing(false);
        }
    }
    const [assignedFormValues, setAssignedFormValues] = useState({
        roleId: '-1',
        organizationId: localStorage.getItem('clientID'),
        userId: '',
        fileDetailIds: [],
        file: null, // Store the single file
        preview: '', // Store the preview URL
    });
    const [inputKey, setInputKey] = useState(Date.now()); // Unique key to reset input
    const fileInputRef = useRef(null); // Create a ref for the input field
    const onCheck = (fileDetailsId) => {
        setCheckedItems((prevCheckedItems) => {
            const isChecked = prevCheckedItems.includes(fileDetailsId);
            return isChecked
                ? prevCheckedItems.filter(item => item !== fileDetailsId)
                : [...prevCheckedItems, fileDetailsId];
        });
    };

    const handleCheckAll = () => {
        const allIds = list.map(item => item.fileDetailsId);
        if (checkedItems.length === allIds.length) {
            setCheckedItems([]); // Uncheck all
        } else {
            setCheckedItems(allIds); // Check all
        }
    };

    // useEffect(() => {
    //     setCheckedItems([]);
    //     const getUsers = async () => {
    //         try {
    //             const userData = await fetchUserDataByClient(localStorage.getItem('clientID'));
    //             setUsers(userData.map(user => ({ value: user.userId, label: user.userName })));
    //         } catch (error) {
    //             console.error("Error fetching clients:", error);
    //         }
    //     };
    //     getUsers();
    // }, []);
    useEffect(() => {
        setCheckedItems([]);
        const fetchRolesByClient = async (clientId) => {
            try {
                const roleData = await fetchRoleData(clientId);
                setRoles([{ value: -1, label: 'All' }, ...roleData.map(role => ({ value: role.roleId, label: role.roleName }))]);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };
        fetchRolesByClient(localStorage.getItem('clientID'));
    }, []);
    const handleRoleChange = (option) => {
        const selectedRoleId = option.value;
        getUsersByRole(selectedRoleId);
        setAssignedFormValues({
            ...assignedFormValues,
            roleId: selectedRoleId
        });
    };

    const getUsersByRole = async (roleId) => {
        try {
            const userData = await fetchUserDataByRole(localStorage.getItem('clientID'), roleId);
            setUsers(userData.map(user => ({ value: user.userId, label: user.userName })));
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };
    const openModal = () => {
        setAssignedFormValues(prevValues => ({
            ...prevValues,
            preview: '' // Clear the image preview
        }));
        URL.revokeObjectURL(assignedFormValues.preview);
        if (checkedItems.length > 0) {
            const checkedRowsText = checkedItems
                .map(id => {
                    const item = list.find(file => file.fileDetailsId === id);
                    return `${item.subClientName} & ${item.checkinId}`;
                })
                .join(', ');
            setModalText(checkedRowsText);
            setIsModalOpen(true);
        } else {
            alert('Please select at least one record.');
            return;
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleModalSubmit = async () => {
        
        const updatedFormValues = { ...assignedFormValues, fileDetailIds: checkedItems };
        //console.log(updatedFormValues); // You should see the clientId now included here
        if (!updatedFormValues.userId) {
            alert("Please select user");
            return;
        }
        if(checkedItems.length>1 &&  updatedFormValues.file!=null){
            alert("For multiple allocations attachment not allowed!");
            return; 
        }
        setIsProcessing(true);
        const formData = new FormData();
        formData.append('userId', updatedFormValues.userId);
        formData.append('fileDetailIds', checkedItems);
        formData.append('organizationId', updatedFormValues.organizationId);
        formData.append('file', updatedFormValues.file);
        const data = await assignFileDetailsToFO(formData);
        try {
            if (data.success) {
                setCheckedItems([]);
                handleTableRefresh(); // Trigger re-fetching of files    
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Successfully Allocated",
                    confirmButtonColor: "#4CAF50",
                    allowOutsideClick: false, // Prevent closing by clicking outside
                    allowEscapeKey: false,    // Prevent closing with the Escape key
                });
                //alert('Successfully Allocated');
                closeModal();

            } else {
                alert('No Data Found');
            }
        } catch (error) {
            console.error("Submission failed:", error);
            alert('Failed to submit form. Please try again.');
        } finally {
            setIsProcessing(false);
          }
        //console.log('Selected Option:', assignedFormValues.userId);
        //console.log('Selected Records:', checkedItems);
    };

    if (!list || list.length === 0) {
        return <div>No files found. Please adjust your filters.</div>;
    }

    const tableHeaders = [".", "Client Name", "Branch", "Checkin ID", "Customer Name", "Address", "Component", "TAT (Days)"];
    const headerMapping = {
        ".": "check",
        "Client Name": "subClientName",
        "Branch": "branchName",
        "Checkin ID": "checkinId",
        "Customer Name": "customerName",
        "Address": "address",
        "Component": "componentName",
        "TAT (Days)": "tat"
    };
    const handleAssign = (rowObject) => {
        // Add the fileDetailsId of the clicked row to checkedItems
        setCheckedItems([rowObject.fileDetailsId]);
        const checkedRowText = `${rowObject.subClientName} & ${rowObject.checkinId}`;
        setModalText(checkedRowText);
        setAssignedFormValues(prevValues => ({
            ...prevValues,
            preview: '' // Clear the image preview
        }));
        URL.revokeObjectURL(assignedFormValues.preview);
        setIsModalOpen(true); // Open the modal after selecting the row
    };

    const onSuccessUpdate = () => {
        //console.log(templateContent)
        setTemplateContent("");
        //setIsOpen(false);
        toggleDialog(); // Open the dialog after fetching content
        handleTableRefresh(); // Trigger re-fetching of files    
    }


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setAssignedFormValues({
                ...assignedFormValues,
                file,
                preview: URL.createObjectURL(file), // Create a preview URL
            });
            // if (file && file.type === 'application/pdf') {
            //     setPreviewUrl(URL.createObjectURL(file));
            // } else {
            //     alert('Please select a valid PDF file.');
            // }
        }
    };
    const handleRemove = () => {
        // Revoke the object URL to free up memory
        if (assignedFormValues.preview) {
            URL.revokeObjectURL(assignedFormValues.preview);
        }

        // Reset the file and preview in the state
        setAssignedFormValues((prevValues) => ({
            ...prevValues,
            file: null,
            preview: '',
        }));

        // Reset file input by changing its key
        setInputKey(Date.now());
    };

    return (
        <div className="container mx-auto p-6 bg-white rounded-lg border">
            <button onClick={openModal} className="mb-4 bg-green-500 text-white px-4 py-2 rounded">
                ALLOCATE
            </button>

            <AdvancedDataTableComponent
                headers={tableHeaders}
                data={list.map((item, index) => ({
                    ...item,
                    check: (
                        <input
                            type="checkbox" class="checkbox-box w-5 h-5 border-2 border-gray-300 rounded-full bg-white bg-opacity-20 backdrop-blur-md checked:bg-blue-500 checked:border-blue-500 focus:ring-0 transition-colors duration-300 ease-in-out transform scale-100 hover:scale-105 shadow-sm hover:shadow-md"
                            checked={checkedItems.includes(item.fileDetailsId)}
                            onChange={() => onCheck(item.fileDetailsId)}
                        />
                    ),
                    popup_show: (

                        <input
                            type="button"
                            value="Show"
                            onClick={() => handleShowPopoUpSubmit(item.fileDetailsId)}
                        />
                    ),

                }))}
                headerMapping={headerMapping}
                onEdit={handleAssign}
                showActions={true}
                buttonLableName="Allocate"
                onCheckAll={handleCheckAll}
                checkedItems={checkedItems}
                extatAction={true}
                extraActionMethod={handleShowPopoUpSubmit}
            />

            <Modal
                isOpen={isModalOpen}
                onClose={closeModal}
                onSubmit={handleModalSubmit}
            >
                <div className="modal-content">
                    {/* <textarea
                        value={modalText}
                        onChange={(e) => setModalText(e.target.value)}
                        rows={4}
                        className="w-full p-2 border rounded mb-4"
                        readOnly
                    /> */}
                    <div>Allocation</div>
                    <div className="mt-4">
                        <>
                            <FloatingLabelSelect
                                label="Select Role"
                                id="roleId"
                                name="roleId"
                                value={roles.find(role => role.value === assignedFormValues.roleId) || null} // Use null if no state is selected
                                onChange={handleRoleChange}
                                options={roles}
                                isSearchable={true}
                            />
                        </>
                    </div>
                    <div className="mt-4">
                        <FloatingLabelSelect
                            label="Select User"
                            id="userId"
                            name="userId"
                            value={users.find(user => user.value === assignedFormValues.userId) || null}
                            onChange={(option) => setAssignedFormValues({ ...assignedFormValues, userId: option.value })}
                            options={users}
                            isSearchable={true}
                        />
                    </div>
                    <div className="mt-4">
                        <input
                            key={inputKey} // Changes key to force re-render
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            className="file-input"
                            ref={fileInputRef}
                        />
                        <p className="text-sm text-gray-600 mt-2">
                            Accepted formats: .jpg, .jpeg, .png, .gif, .svg, .bmp
                        </p>
                        {assignedFormValues.preview && (
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                <br />
                                <img src={assignedFormValues.preview} alt="Preview" className="image-preview" />
                                <button
                                    onClick={handleRemove}
                                    className="remove-button"
                                    style={{
                                        position: 'absolute',
                                        top: '5px',
                                        right: '5px',
                                        background: 'rgba(255, 255, 255, 0.7)', // Optional: background for better visibility
                                        border: 'none',
                                        borderRadius: '50%',
                                        cursor: 'pointer',
                                        padding: '5px',
                                        color: 'red', // Change color to highlight
                                        fontSize: '20px', // Adjust size as needed
                                    }}
                                >
                                    <FaTimes /> {/* Font Awesome X mark icon */}
                                </button>
                            </div>
                        )}
                    </div>
                    <div>
                        {/* <input
                            type="file"
                            accept="application/pdf"
                            onChange={handleFileChange}
                            className="file-input"
                        />
                         {previewUrl && (
                            <iframe
                                src={previewUrl}
                                //width="600"
                                //height="400"
                                title="PDF Preview"
                            />
                        )} */}
                    </div>
                    {/* <div className="mt-4">
                        <button 
                            onClick={() => handleModalSubmit(modalText)} 
                            className="bg-blue-500 text-white px-4 py-2 rounded"
                        >
                            Submit
                        </button>
                    </div> */}
                </div>
            </Modal>
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="relative bg-white w-11/12 max-w-4xl p-6 rounded shadow-lg overflow-auto max-h-screen">
                        {/* Close Button */}
                        <button
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                            onClick={toggleDialog}
                        >
                            ✖
                        </button>

                        {/* Render the template content as a JSON table */}
                        {templateContent && templateContent.length > 0 &&
                            <div>
                                <JsonTable data={templateContent} onSuccess={onSuccessUpdate} /></div>}
                    </div>
                </div>
            )}
            {/* Display the overlay when processing */}
            <ProcessingOverlay isProcessing={isProcessing} message="Please wait, we're processing your request..." />
        </div>
    );
};


const TestPage = () => {

    const [searchResults, setSearchResults] = useState([]);
    const handleTableRefresh = async () => {
        // This calls `handleSubmit` in `FileAssigningForm` to re-fetch the files
        const form = document.querySelector("form");
        if (form) {
            form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        }
    };
    return (
        <div>
            <FileAssigningForm setSearchResults={setSearchResults} handleTableRefresh={handleTableRefresh} />
            {searchResults.length > 0 ? (
                <FilesListTable list={searchResults} handleTableRefresh={handleTableRefresh} />
            ) : (
                <div></div>
            )}

        </div>
    )
};

export default TestPage;


const JsonTable = ({ data, onSuccess }) => {
    const [isEditable, setIsEditable] = useState(false);  // Track if the table is in editable state
    const [modifiedData, setModifiedData] = useState(data); // Store modified data
    const [isProcessing, setIsProcessing] = useState(false);

    // Check if data is a string and parse it if so
    let parsedData = modifiedData;
    if (typeof parsedData === 'string') {
        try {
            parsedData = JSON.parse(parsedData);
            setModifiedData(parsedData);
        } catch (e) {
            // If parsing fails, show an error message
            return <div className="text-red-500">Error: Invalid JSON string</div>;
        }
    }

    // Check if parsedData is an object
    if (!parsedData || typeof parsedData !== 'object') {
        return <div>No data available</div>;
    }

    // Get the keys of the object to display each key-value pair
    const keys = Object.keys(parsedData);

    const handleEditClick = () => {
        setIsEditable(!isEditable); // Toggle editable state
    };

    const handleInputChange = (e, key) => {
        setModifiedData({
            ...modifiedData,
            [key]: e.target.value,
        });
    };

    const handleSave = async () => {
        // Send modifiedData to API (for example)
        setIsProcessing(true);
        try {
            const data = await updatefiledetails(modifiedData);
            //console.log(data);
            if (!data.error) {
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: data.success,
                    confirmButtonColor: "#4CAF50",
                    allowOutsideClick: false, // Prevent closing by clicking outside
                    allowEscapeKey: false,    // Prevent closing with the Escape key
                }).then(() => {
                    setIsEditable(false);
                    if (onSuccess) onSuccess(); // Call the callback only if it exists
                });

            } else {
                Swal.fire("Error", 'Failed to submit form. Please try again.' + data.error, "error");
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setIsProcessing(false);
        }
    };

    const handleDeleteFileDetails = async (rowObject) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Are you sure want to delete this component?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#4CAF50",
            confirmButtonText: "Yes, Delete it!",
            cancelButtonText: "Cancel",
            allowOutsideClick: false,
            allowEscapeKey: false,
        });

        if (result.isConfirmed) {
            setIsProcessing(true);
            try {
                const response = await deletefiledetails(modifiedData.fileDetailsId, localStorage.getItem('userID'));
                if (!response.error) {
                    Swal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: "Your data has been Deleted successfully.",
                        confirmButtonColor: "#4CAF50",
                    }).then(() => {
                        setIsEditable(false);
                        if (onSuccess) onSuccess(); // Call the callback only if it exists
                    });
                } else {
                    Swal.fire("Error", "Failed to save data. " + response.error, "error");
                }
            } catch (error) {
                Swal.fire("Error", "An unexpected error occurred.", "error");
            } finally {
                setIsProcessing(false);
            }
        }

    }

    return (
        <div className="overflow-x-auto">
            <div className="flex justify-between items-center mb-4">
                <button
                    onClick={handleEditClick}
                    className="px-4 py-2 bg-blue-500 text-white rounded-lg"
                >
                    {isEditable ? 'Cancel Edit' : 'Edit'}
                </button>
                {isEditable && (
                    <button
                        onClick={handleSave}
                        className="px-4 py-2 bg-green-500 text-white rounded-lg"
                    >
                        Save Changes
                    </button>
                )}
            </div>
            <table className="min-w-full table-auto bg-white bg-opacity-30 shadow-lg rounded-lg border border-gray-200">
                <thead className="bg-blue-200 bg-opacity-80">
                    <tr>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Field</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Value</th>
                    </tr>
                </thead>
                <tbody>
                    {keys
                        .filter((key) => key !== "fileDetailsId")
                        .map((key, index) => (
                            <tr
                                key={key}
                                className={`${index % 2 === 0
                                    ? 'bg-blue-50 bg-opacity-70'
                                    : 'bg-green-50 bg-opacity-70'
                                    } hover:bg-blue-100 hover:bg-opacity-70 transition-colors duration-300`}
                            >
                                <td className="px-6 py-3 text-sm text-gray-800 font-medium">{key}</td>
                                <td className="px-6 py-3 text-sm text-gray-600">
                                    {isEditable ? (
                                        parsedData[key]?.length > 30 ? (
                                            <textarea
                                                value={parsedData[key]}
                                                onChange={(e) => handleInputChange(e, key)}
                                                className="px-4 py-2 border border-gray-300 bg-transparent rounded-md text-gray-800 focus:ring-2 focus:ring-blue-400 w-full h-24 resize-none"
                                            />
                                        ) : (
                                            <input
                                                type="text"
                                                value={parsedData[key]}
                                                onChange={(e) => handleInputChange(e, key)}
                                                className="px-4 py-2 border border-gray-300 bg-transparent rounded-md text-gray-800 focus:ring-2 focus:ring-blue-400"
                                            />
                                        )
                                    ) : (
                                        parsedData[key]
                                    )}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
            <div className="text-right mt-4">
                <button
                    onClick={handleDeleteFileDetails}
                    className="px-4 py-2 bg-red-500 text-white rounded-lg"
                    disabled={isProcessing}
                >
                    Delete
                </button>
            </div>

            {/* Display the overlay when processing */}
            <ProcessingOverlay isProcessing={isProcessing} message="Please wait, we're processing your request..." />
        </div>
    );
};




